"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.Root = exports.Icon = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('a')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        boxSizing: 'border-box',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        minHeight: 50,
        color: theme.palette.text.secondary,
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.text.secondary
        },
        '&:not(:last-of-type)': {
            borderBottom: "2px solid ".concat(theme.palette.grey[100])
        },
        '&:last-child': {
            marginBottom: theme.spacing(3)
        }
    };
});
const Title = exports.Title = (0, _mui.styled)('h3', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, truncate } = param;
    return {
        flex: 1,
        margin: theme.spacing(3, 0),
        fontSize: '1.5rem',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: 1.25,
        ...Boolean(truncate) && {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: truncate,
            overflow: 'hidden'
        }
    };
});
const Icon = exports.Icon = (0, _mui.styled)('span')({
    flexBasis: '40px',
    fontSize: '2.4rem',
    textAlign: 'end'
});
